import * as React from 'react'
import { Content, Heading, Row, Wrapper } from './FormSection.styles'

type FormSectionProps = {
  title: string,
  className?: string,
  children?: React.ReactNode
}

const FormSection: React.FunctionComponent<FormSectionProps> = ({ title, children, className }) => (
  <Wrapper className={className}>
    <Heading>{title}</Heading>
    <Content className="content">{children}</Content>
  </Wrapper>
)

export const FormSectionRow = Row

export default FormSection
